require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-143-gantt-view.json") })
        }
      }, "path---article-143-gantt-view");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-143-gantt-view!./.cache/json/article-143-gantt-view.json
// module id = 493
// module chunks = 231608221292675